import { render } from "./BookTypeTable.vue?vue&type=template&id=b04495f2"
import script from "./BookTypeTable.vue?vue&type=script&lang=js"
export * from "./BookTypeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__